import t from"react-dom";import{setBatchedUpdates as r}from"@reatom/react-v2";r(t.unstable_batchedUpdates);
//# sourceMappingURL=react-dom-batched-updates.module.js.map
